import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MaterialPriceWriteReceiptFragment = { __typename?: 'MaterialPriceWriteReceipt', kind: Types.MaterialPriceOperationKind, materialItemId: string, operationId: string, priceId: string, priceRevision: number, purchasingRevision: number, recorded: Types.TDateISO };

export type AddEffectiveMaterialPriceMutationVariables = Types.Exact<{
  input: Types.AddEffectiveMaterialPriceInput;
}>;


export type AddEffectiveMaterialPriceMutation = { __typename?: 'Mutation', addEffectiveMaterialPrice: { __typename?: 'MaterialPriceWritePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, receipt?: { __typename?: 'MaterialPriceWriteReceipt', kind: Types.MaterialPriceOperationKind, materialItemId: string, operationId: string, priceId: string, priceRevision: number, purchasingRevision: number, recorded: Types.TDateISO } | null } };

export type CorrectMaterialPriceMutationVariables = Types.Exact<{
  input: Types.CorrectMaterialPriceInput;
}>;


export type CorrectMaterialPriceMutation = { __typename?: 'Mutation', correctMaterialPrice: { __typename?: 'MaterialPriceWritePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, receipt?: { __typename?: 'MaterialPriceWriteReceipt', kind: Types.MaterialPriceOperationKind, materialItemId: string, operationId: string, priceId: string, priceRevision: number, purchasingRevision: number, recorded: Types.TDateISO } | null } };

export type VoidMaterialPriceMutationVariables = Types.Exact<{
  input: Types.VoidMaterialPriceInput;
}>;


export type VoidMaterialPriceMutation = { __typename?: 'Mutation', voidMaterialPrice: { __typename?: 'MaterialPriceWritePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, receipt?: { __typename?: 'MaterialPriceWriteReceipt', kind: Types.MaterialPriceOperationKind, materialItemId: string, operationId: string, priceId: string, priceRevision: number, purchasingRevision: number, recorded: Types.TDateISO } | null } };

export const MaterialPriceWriteReceiptFragmentDoc = new TypedDocumentString(`
    fragment MaterialPriceWriteReceipt on MaterialPriceWriteReceipt {
  kind
  materialItemId
  operationId
  priceId
  priceRevision
  purchasingRevision
  recorded
}
    `, {"fragmentName":"MaterialPriceWriteReceipt"});
export const AddEffectiveMaterialPriceDocument = new TypedDocumentString(`
    mutation AddEffectiveMaterialPrice($input: AddEffectiveMaterialPriceInput!) {
  addEffectiveMaterialPrice(input: $input) {
    errors {
      code
      message
    }
    receipt {
      ...MaterialPriceWriteReceipt
    }
  }
}
    fragment MaterialPriceWriteReceipt on MaterialPriceWriteReceipt {
  kind
  materialItemId
  operationId
  priceId
  priceRevision
  purchasingRevision
  recorded
}`);
export const CorrectMaterialPriceDocument = new TypedDocumentString(`
    mutation CorrectMaterialPrice($input: CorrectMaterialPriceInput!) {
  correctMaterialPrice(input: $input) {
    errors {
      code
      message
    }
    receipt {
      ...MaterialPriceWriteReceipt
    }
  }
}
    fragment MaterialPriceWriteReceipt on MaterialPriceWriteReceipt {
  kind
  materialItemId
  operationId
  priceId
  priceRevision
  purchasingRevision
  recorded
}`);
export const VoidMaterialPriceDocument = new TypedDocumentString(`
    mutation VoidMaterialPrice($input: VoidMaterialPriceInput!) {
  voidMaterialPrice(input: $input) {
    errors {
      code
      message
    }
    receipt {
      ...MaterialPriceWriteReceipt
    }
  }
}
    fragment MaterialPriceWriteReceipt on MaterialPriceWriteReceipt {
  kind
  materialItemId
  operationId
  priceId
  priceRevision
  purchasingRevision
  recorded
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddEffectiveMaterialPrice: build.mutation<AddEffectiveMaterialPriceMutation, AddEffectiveMaterialPriceMutationVariables>({
      query: (variables) => ({ document: AddEffectiveMaterialPriceDocument, variables })
    }),
    CorrectMaterialPrice: build.mutation<CorrectMaterialPriceMutation, CorrectMaterialPriceMutationVariables>({
      query: (variables) => ({ document: CorrectMaterialPriceDocument, variables })
    }),
    VoidMaterialPrice: build.mutation<VoidMaterialPriceMutation, VoidMaterialPriceMutationVariables>({
      query: (variables) => ({ document: VoidMaterialPriceDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddEffectiveMaterialPriceMutation, useCorrectMaterialPriceMutation, useVoidMaterialPriceMutation } = injectedRtkApi;
